export default class Employee {
    email?:string;
    name?:string;
    phone_no?:number;
}
